<template>
  <rest
    ref="rest"
    :remote="remote"
    :table-columns="tableColumns"
    :formInitialize="formInitialize"
    :form-rules="formRules"
    :create-able="true"
    :update-able="true"
    :delete-able="true"
    :exportable="true"
    :export-visible="true"
    :use-drawer="true"
    drawer-width="50%"
  >
    <template v-slot:tableColumn-products="{row}">
      <div class="products-tag-container" @click="handleUpdateProducts(row)">
        <template v-if="row.products && parseProducts(row.products).length">
          <el-tag
            v-for="item in parseProducts(row.products).slice(0, 3)"
            :key="item.id || item.name"
            size="mini"
            type="info"
            class="product-price-tag"
          >
            ¥{{ item.price }}
          </el-tag>
          <el-tag v-if="parseProducts(row.products).length > 3" size="mini" type="info" class="product-price-tag more-tag">
            +{{ parseProducts(row.products).length - 3 }}
          </el-tag>
        </template>
        <span v-else class="text-muted">-</span>
      </div>
    </template>
  </rest>
</template>

<script>
import Rest from '@/components/Spring/Rest'

export default {
  name: 'mchApples',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: false,
        reloadUrl: '/channel/admin/cache/reload/mch/apple',
        reloadLabel: '重载NACOS-Apple应用',
        createLabel: '新增Apple应用'
      },
      formInitialize: {
        products: []
      },
      formRules: {
        name: [{ required: true, message: '请填写名称' }],
        appId: [{ required: true, message: '请填写应用ID' }],
        bundleId: [{ required: true, message: '请填写BundleID' }],
        issuerId: [{ required: true, message: '请填写IssuerID' }],
        kid: [{ required: true, message: '请填写KID' }],
        appPrivateKey: [{ required: true, message: '请填写PrivateKey' }]
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true },
        { label: '名称', prop: 'name' },
        { label: '应用ID', prop: 'appId' },
        { label: 'BundleID', prop: 'bundleId' },
        { label: 'IssuerID', prop: 'issuerId' },
        { label: 'KID', prop: 'kid' },
        { label: 'PrivateKey', prop: 'appPrivateKey', type: 'extTextPopover' },
        { label: '商品挡位', prop: 'products', type: 'appleProducts', codec: 'json', hideFormLabel: true }
      ]
    }
  },
  methods: {
    parseProducts (productsStr) {
      try {
        if (!productsStr) return []
        const data = typeof productsStr === 'string' ? JSON.parse(productsStr) : productsStr
        return Array.isArray(data) ? data : []
      } catch (e) {
        return []
      }
    },
    handleUpdateProducts (row) {
      if (this.$refs.rest) {
        this.$refs.rest.handleActionCommand('edit', row)
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.products-tag-container {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
  min-height: 24px;
  width: 100%;
  cursor: pointer;
}

.product-price-tag {
  background-color: var(--bg-hover) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  font-weight: 600 !important;
  border-radius: 6px !important;
  transition: all 0.2s ease;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.products-tag-container:hover .product-price-tag {
  background-color: rgba(37, 99, 235, 0.06) !important;
  border-color: rgba(37, 99, 235, 0.15) !important;
  color: var(--primary-color) !important;
}

.product-price-tag.more-tag {
  background-color: var(--border-color) !important;
  border-color: var(--border-hover) !important;
  color: var(--text-muted) !important;
}
</style>
